<template>
  <div class="homeMain">
    <div class="homeLeft">
      <div class="map-top">
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle1"
        />
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle2"
        />
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle3"
        />
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle4"
        />
        <div class="selectMap">
          <el-select
            v-model="selectLookMapIndex"
            clearable
            placeholder="请选择"
            @change="changeMap"
            :popper-append-to-body="false"
          >
            <el-option value="1" label="院部"></el-option>
            <el-option value="2" label="老人"></el-option>
            <el-option value="3" label="活动"></el-option>
          </el-select>
        </div>
        <div id="serveMap" class="serveMap"></div>
      </div>
      <div class="map-bottom">
        <img
          src="../../../assets/supervise/companyImg.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <div class="old-left">
          <p>老年人分析</p>
          <div class="analyse">
            <div class="analyse-left">
              <div id="ageData"></div>
            </div>
            <div class="analyse-right">
              <div id="moneyData"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="homeCenter">
      <div class="serveObj">
        <img
          src="../../../assets/supervise/demographicIcon.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <div class="serveObjTop">
          <p class="sertitle">养老概况</p>
          <div class="serveBox">
            <div class="serveOther">
              <img src="../../../assets/supervise/zhyly.png" alt="" srcset="" />
              <p>
                <span class="name">床位数</span>
                <br />
                <span class="nums">80</span>
              </p>
            </div>
            <div class="serveOther">
              <img src="../../../assets/supervise/pold.png" alt="" srcset="" />
              <p>
                <span class="name">入院老人</span><br />
                <span class="nums" style="color: #2cd1c0">{{
                  ruyuanOldMan
                }}</span>
              </p>
            </div>
          </div>
          <p class="sertitle today">今日智能监管</p>
          <div class="serveBox">
            <div class="serveOther">
              <p>
                <span class="nums" style="color: #fefe00">{{
                  chuyuanOldMan
                }}</span>
                <br />
                <span class="name">出院老人</span>
              </p>
            </div>
            <div class="serveOther">
              <p>
                <span class="nums" style="color: #975fe4">{{ outtime }}</span>
                <br />
                <span class="name">逾期未归</span>
              </p>
            </div>
            <div class="serveOther">
              <p>
                <span class="nums" style="color: #fbb828">{{ qingjia }}</span>
                <br />
                <span class="name">请假</span>
              </p>
            </div>
          </div>
          <p class="sertitle today">基本情况</p>
          <div class="serveBox">
            <div class="serveOther">
              <div class="servepo">
                <span>94</span>
                <img src="../../../assets/supervise/bg.png" />
              </div>
              <p class="write">工作人员</p>
            </div>
            <div class="serveOther">
              <div class="servepo">
                <span>{{ houseNum }}</span>
                <img src="../../../assets/supervise/bg.png" />
              </div>
              <p class="write">空床位数</p>
            </div>
            <div class="serveOther">
              <div class="servepo">
                <span>{{ builtArea }}</span>
                <img src="../../../assets/supervise/bg.png" />
              </div>
              <p class="write">建筑面积</p>
            </div>
          </div>
        </div>
      </div>
      <div class="demographic">
        <img
          src="../../../assets/supervise/demographicIcon.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <p class="serveTitle">入院老人</p>
        <div id="hospitalOld"></div>
      </div>
    </div>
    <div class="homeRight">
      <div class="serveStation">
        <img
          src="../../../assets/supervise/companyImg.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <div class="over">
          <div style="display: flex" class="overdiv">
            <p class="serveTitle" style="width: 90%">院内监督</p>
            <div
              class="serveTitle"
              style="width: 10%"
              @click="serveClick(1)"
              v-if="this.serveCad == false"
            >
              更多
            </div>
            <div
              class="serveTitle"
              style="width: 10%"
              @click="serveClick(2)"
              v-if="this.serveCad == true"
            >
              返回
            </div>
          </div>
          <div v-if="this.serveCad == false">
            <iframe
              :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${this.vodelist[1].sequence}/${this.vodelist[1].channel}.live&autoplay=1&audio=1&accessToken=${this.vodelist[1].token}&templete=2`"
              width="94%"
              height="300px"
              style="margin: 20px 3%"
              id="ysopen"
              allowfullscreen
            >
            </iframe>
          </div>
          <div v-if="this.serveCad == true">
            <div v-for="(item, index) in this.vodelist" :key="index">
              <iframe
                :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${item.sequence}/${item.channel}.live&autoplay=1&audio=1&accessToken=${item.token}&templete=2`"
                width="94%"
                height="300px"
                style="margin: 20px 3%"
                id="ysopen"
                allowfullscreen
              >
              </iframe>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex">
        <div class="companyServe">
          <img
            src="../../../assets/supervise/companyImg.png"
            class="companyImg"
            alt=""
            srcset=""
          />
          <div class="compayTop">
            <p class="companyName">今日菜单</p>
          </div>
          <div class="tableData">
            <ul>
              <li>早餐</li>
              <li>
                {{ this.mealList[0].foodName }}
              </li>
            </ul>
            <ul>
              <li>午餐</li>
              <li>
                {{ this.mealList[1].foodName }}
              </li>
            </ul>
            <ul>
              <li>晚餐</li>
              <li>
                {{ this.mealList[2].foodName }}
              </li>
            </ul>
          </div>
        </div>
        <div class="companyServe">
          <img
            src="../../../assets/supervise/companyImg.png"
            class="companyImg"
            alt=""
            srcset=""
          />
          <div class="compayTop">
            <p class="companyName">健康情况分析</p>
          </div>

          <div class="tableData">
            <div id="coesada"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 养老院弹框 -->
    <el-dialog
      title="养老院信息"
      :visible.sync="partVisible"
      @close="partVisible == false"
    >
      <img
        src="../../../assets/supervise/companyImg.png"
        class="companyImg"
        alt=""
        srcset=""
      />
      <div class="dialogConent">
        <ul>
          <li>
            <p>
              <span>机构名称:</span><span>{{ partInfo.mechanismName }}</span>
            </p>
            <p>
              <span>机构类型:</span
              ><span v-if="partInfo.mechanismType == 0">养老机构</span>
              <span v-if="partInfo.mechanismType == 1">日间照料中心</span>
              <span v-if="partInfo.mechanismType == 2"
                >城乡居家养老机构(幸福苑)</span
              >
              <span v-if="partInfo.mechanismType == 3">合作服务商</span>
              <span v-if="partInfo.mechanismType == 4">其他</span>
            </p>
          </li>
          <li>
            <p>
              <span>机构地址:</span><span>{{ partInfo.address }}</span>
            </p>
          </li>
          <li>
            <p>
              <span>机构负责人:</span><span>{{ partInfo.chargePerson }}</span>
            </p>
            <p>
              <span>联系方式:</span><span>{{ partInfo.phone }}</span>
            </p>
          </li>
          <li>
            <p>
              <span>床位数:</span><span>{{ partInfo.bedsNumber }}</span>
            </p>
          </li>
        </ul>
      </div>
    </el-dialog>
    <!-- 老人信息弹窗 -->
    <el-dialog
      title="老人信息"
      :visible.sync="isShowOld"
      @close="isShowOld == false"
    >
      <img
        src="../../../assets/supervise/companyImg.png"
        class="companyImg"
        alt=""
        srcset=""
      />
      <div class="dialogConent">
        <ul>
          <li>
            <p>
              <span>姓名：</span><span>{{ olderInfo.name }}</span>
            </p>
            <p>
              <span>性别：</span
              ><span>{{ olderInfo.gender == 1 ? "女" : "男" }}</span>
            </p>
          </li>
          <li>
            <p>
              <span>年龄：</span><span>{{ olderInfo.age }}</span>
            </p>
            <p>
              <span>手机号码：</span><span>{{ olderInfo.phone }}</span>
            </p>
          </li>
          <li>
            <p>
              <span>地址：</span><span>{{ olderInfo.address }}</span>
            </p>
          </li>
          <li>
            <p>
              <span>入院时间: </span><span>{{ olderInfo.intoTime }}</span>
            </p>
            <p>
              <span>有无试住:</span
              ><span>{{ olderInfo.intoType == 0 ? "无" : "有" }}</span>
            </p>
          </li>
          <li>
            <p>
              <span>计费开始日期: </span
              ><span>{{ olderInfo.chargingTime }}</span>
            </p>
          </li>
          <!-- <li>
                        <p><span>饮食禁忌:</span>
                        
                        <span v-if="olderInfo.dietTaboo == 0">糖</span>
                        <span v-if="olderInfo.dietTaboo == 1">海鲜</span>
                        <span v-if="olderInfo.dietTaboo == 2">蛋类</span>
                        <span v-if="olderInfo.dietTaboo == 3">豆制品</span>
                        <span v-if="olderInfo.dietTaboo == 4">其他</span></p>
                        <p><span>自理情况:</span><span v-if="olderInfo.selfCare == 0" >较差，完全需要别人照顾</span>
                        <span v-if="olderInfo.selfCare == 1">一般，有些事情需要别人照顾</span>
                        <span v-if="olderInfo.selfCare == 2">较好，一般不需要别人照顾</span>
                        <span v-if="olderInfo.selfCare == 3">很好，还可以照顾别人</span></p>
                    </li>
                    <li>
                        <p><span>健康情况:</span><span v-if="olderInfo.health == 0">身体健康</span>
                        <span v-if="olderInfo.health == 1">高血压</span>
                        <span v-if="olderInfo.health == 2">冠心病</span>
                        <span v-if="olderInfo.health == 3">脑卒中</span>
                        <span v-if="olderInfo.health == 4">糖尿病</span>
                        <span v-if="olderInfo.health == 5">类风湿</span>
                        <span v-if="olderInfo.health == 6">脑出血</span>
                        <span v-if="olderInfo.health == 7">高血脂</span>
                        <span v-if="olderInfo.health == 8">系统性狼疮</span>
                        <span v-if="olderInfo.health == 9">恶性肿瘤</span>
                        <span v-if="olderInfo.health == 10">恶性肿瘤</span>
                        <span v-if="olderInfo.health == 11">结核病</span>
                        <span v-if="olderInfo.health == 12">肝炎</span>
                        <span v-if="olderInfo.health == 13">其他法定传染病</span>
                        <span v-else>其他</span></p>
                    </li> -->
        </ul>
      </div>
    </el-dialog>
    <!-- 活动地点老人打点弹框 -->
    <el-dialog
      title="活动信息"
      :visible.sync="activeVisible"
      @close="activeVisible == false"
    >
      <img
        src="../../../assets/supervise/companyImg.png"
        class="companyImg"
        alt=""
        srcset=""
      />
      <div class="dialogConent">
        <ul>
          <li>
            <p>
              <span>活动名称: </span><span>{{ activeInfo.mechanismName }}</span>
            </p>
            <div class="activeImg">
              <el-image
                style="width: 100px; height: 100px"
                :src="activeInfo.photo"
                fit="contain"
                v-if="activeInfo.photo != ''"
              ></el-image>
            </div>
          </li>
          <li>
            <p>
              <span>活动类型: </span
              ><span>{{ activeInfo.activityTypeName }}</span>
            </p>
          </li>
          <li>
            <p>
              <span>活动时间: </span><span>{{ activeInfo.activityTime }}</span>
            </p>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
export default {
  data() {
    return {
      selectLookMapIndex: "",
      myMap: null,
      markers: [],
      zoom: 10,
      partList: [], // 院部列表
      oldList: [],
      activeList: [],
      partVisible: false, // 院部详情弹窗
      isShowOld: false, // 老人信息详情弹窗
      activeVisible: false, // 活动详情弹窗
      olderInfo: {}, // 老人详情信息
      partInfo: {}, // 院部详情信息
      activeInfo: {}, // 活动详情信息
      centerPoint: [117.306799, 31.748054],
      ageData: [],
      ruyuanOldMan: [],
      chuyuanOldMan: [],
      oldNumList: [],
      oldManNumList: [],
      oldWomenNumList: [],
      healthyList: [],
      healthyNum: 0,
      qingjia: 0,
      outtime: 0, //逾期未归
      builtArea: 0, //建筑面积
      houseNum: 0,
      mealList: [{ foodName: "" }, { foodName: "" }, { foodName: "" }],
      serveCad: false,
      vodeSrc: "",
      vodelist: [
        {
          sequence: "",
          token: "",
          channel: "",
        },
        {
          sequence: "",
          token: "",
          channel: "",
        },
        {
          sequence: "",
          token: "",
          channel: "",
        },
      ],
      control: "",
    }
  },
  created() {
    this.actionUrl =
      baseURL + "/jgyl/controller/uploadController/info/uploadPhoto"
  },
  mounted() {
    this.$nextTick(() => {
      let that = this
      // console.log(that.centerPoint)
      that.myMap = new AMap.Map("serveMap", {
        center: [that.centerPoint[0], that.centerPoint[1]],
        resizeEnable: true,
        viewMode: "3D", //使用3D视图
        zoom: 50,
        defaultCursor: "default",
        defaultCursor: "pointer",
        showBuildingBlock: false,
        expandZoomRange: true,
        mapStyle: "amap://styles/blue",
      })
    })
    this.getOldList() // 获取老人列表
    this.getActiveList() // 获取活动列表
    this.getPartList() // 获取院部信息
    this.getAge() // 获取老人年龄段
    this.getaskLeave() // 获取请假老人数
    this.getOutTime() // 获取逾期的老人数
    this.getHouse() // 获取占地面积
    this.getMealList() // 获取菜单
    this.getMoneyss() // 获取疾病统计

    this.getvode() // 获取单个监控
    this.getvodes() // 获取多个监控
  },
  methods: {
    // 获取老人列表
    getOldList() {
      this.$http
        .request({
          url: "jgyl/admin/register/info/findList",
          method: "POST",
          data: {
            pageSize: 1000,
            pageNo: 1,
          },
        })
        .then((res) => {
          console.log(res)
          if (res.code == 200) {
            if (res.content == null) {
              this.oldList = []
            } else {
              this.oldList = res.content.list
            }
          }
        })
    },
    // 获取活动列表
    getActiveList() {
      this.$http
        .request({
          url: "jgyl/admin/institutionalActivities/info/findList",
          method: "POST",
          data: {
            pageSize: 1000,
            pageNo: 1,
          },
        })
        .then((res) => {
          // console.log(res)
          if (res.code == 200) {
            if (res.content == null) {
              this.activeList = []
            } else {
              this.activeList = res.content.list
            }
          }
        })
    },
    // 获取院部信息
    getPartList() {
      this.$http
        .request({
          url: "jgyl/admin/institute/info/findList",
          method: "POST",
          data: {
            pageSize: 1000,
            pageNo: 1,
          },
        })
        .then((res) => {
          // console.log(res)
          if (res.code == 200) {
            if (res.content == null) {
              this.partList = []
            } else {
              this.partList = res.content.list
            }
          }
        })
    },
    //获取监控链接
    getvode() {
      fetch("https://open.ys7.com/api/lapp/token/get", {
        method: "POST",
        body: `appKey=${this.accessKey}&appSecret=${this.accessSecret}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }).then((res) => {
        // console.log(res)
        if (res.data.accessToken) {
          this.control = res.data.accessToken
        } else {
          this.control = ""
        }
      })
    },
    getvodes() {
      this.$http
        .request({
          url: "ypt/admin/monitorManagement/info/getMonitor",
          method: "POST",
          data: {
            flag: 11,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content) {
              // console.log(res)
              this.vodelist = res.content
              // console.log(this.vodelist[0].token, "监控")
            }
          }
        })
    },
    //切换地图打点
    changeMap(val) {
      // console.log(val)
      this.myMap.remove(this.markers)
      this.markers = []
      // console.log(this.markers)
      if (val == 1 && this.partList.length > 0) {
        this.getCenterPoint(this.partList, 1)
        //养老院
        this.partList.forEach((item) => {
          this.setMarker(item, 1)
        })
      } else if (val == 2 && this.oldList.length > 0) {
        //老人打点
        this.getCenterPoint(this.oldList, 2)
        this.oldList.forEach((item) => {
          this.setMarker(item, 2)
        })
      } else if (this.activeList.length > 0) {
        //活动打点
        this.getCenterPoint(this.activeList, 3)
        this.activeList.forEach((item) => {
          this.setMarker(item, 3)
        })
      }
    },
    // 在地图上打点
    setMarker(data, type) {
      // 选定网格
      // console.log(data, type)
      if (type == 1) {
        var icon = new AMap.Icon({
          image: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
          imageSize: new AMap.Size(25, 30),
          // imageOffset: new AMap.Pixel(-95, -3)
        })
        var marker = new AMap.Marker({
          position: new AMap.LngLat(data.addressLng, data.addressLat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          icon: icon,
        })
      } else if (type == 2) {
        var icon = new AMap.Icon({
          image: require("@/assets/supervise/pold.png"),
          imageSize: new AMap.Size(25, 30),
          // imageOffset: new AMap.Pixel(-95, -3)
        })
        var marker = new AMap.Marker({
          position: new AMap.LngLat(data.longitude, data.latitude), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          icon: icon,
        })
      } else {
        var icon = new AMap.Icon({
          image: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
          imageSize: new AMap.Size(25, 30),
          // imageOffset: new AMap.Pixel(-95, -3)
        })
        var marker = new AMap.Marker({
          position: new AMap.LngLat(data.longitude, data.latitude), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          icon: icon,
        })
      }

      let that = this
      marker.on("click", function () {
        that.getdetail(data, type)
      })
      marker.setTitle(data.name)
      // marker.setLabel({
      //     direction:'top',
      //     offset: new AMap.Pixel(10, 0),  //设置文本标注偏移量
      //     content: "<div class='info'>"+ data.name +"</div>", //设置文本标注内容
      // });

      this.markers.push(marker)
      // console.log(222, this.markers)

      // 将创建的点标记添加到已有的地图实例：
      this.myMap.add(this.markers)
      // 设置可视中心
      // this.map.setFitView(this.circle)
      this.myMap.setZoom(this.zoom)
    },
    // 获取中心点坐标
    getCenterPoint(data, type) {
      // console.log(data,type)
      let lng = 0.0,
        lat = 0.0
      if (type == 1) {
        data.forEach((item) => {
          lng = lng + parseFloat(item.addressLng)
          lat = lat + parseFloat(item.addressLat)
        })
      } else {
        data.forEach((item) => {
          lng = lng + parseFloat(item.longitude)
          lat = lat + parseFloat(item.latitude)
        })
      }

      // console.log(lng, lat)
      lng = lng / data.length
      lat = lat / data.length
      this.centerPoint = [lng, lat]
      // console.log(this.centerPoint)
      //设置地图的中心点
      this.myMap.setCenter(new AMap.LngLat(lng, lat))
    },
    // 获取详情
    getdetail(detail, type) {
      // console.log(detail,type)
      if (type == 1) {
        this.partInfo = detail
        this.partVisible = true
      } else if (type == 2) {
        this.olderInfo = detail
        this.isShowOld = true
        // console.log(this.isShowOld)
      } else {
        this.activeInfo = detail
        this.activeVisible = true
      }
    },
    //年龄段占比
    getAge() {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findAgeAndYlCount",
        method: "POST",
        data: {},
      }).then((res) => {
        if (res.code === 200) {
          // console.log(res)
          if (res.content != null) {
            this.chuyuanOldMan = res.content.chuyuanOldMan
            this.ruyuanOldMan = res.content.ruyuanOldMan

            this.oldNumList = [
              { value: res.content.manage60under, name: "60岁以下" },
              { value: res.content.manage60, name: "60-69岁" },
              { value: res.content.manage70, name: "70-79岁" },
              { value: res.content.manage80, name: "80-89岁" },
              { value: res.content.manage90, name: "90岁以上" },
            ]
            this.echartAge()
            this.oldManNumList = [
              { value: res.content.oldage60under, name: "60岁以下" },
              { value: res.content.oldage60, name: "60-69岁" },
              { value: res.content.oldage70, name: "70-79岁" },
              { value: res.content.oldage80, name: "80-89岁" },
              { value: res.content.oldage90, name: "90岁以上" },
            ]
            this.oldWomenNumList = [
              { value: res.content.womanage60under, name: "60岁以下" },
              { value: res.content.womanage60, name: "60-69岁" },
              { value: res.content.womanage70, name: "70-79岁" },
              { value: res.content.womanage80, name: "80-89岁" },
              { value: res.content.womanage90, name: "90岁以上" },
            ]
            this.healthyList = [
              { value: res.content.selfCare0, name: "重度失能" },
              { value: res.content.selfCare1, name: "中度失能" },
              { value: res.content.selfCare2, name: "轻度失能" },
              { value: res.content.selfCare3, name: "自理老人" },
            ]
            this.healthyNum = res.content.staffCount
            this.healthyEcharts()
            this.echartHosiptial()
          }
        }
      })
    },
    //年龄段饼状图
    echartAge() {
      let myAgeEchart = this.$echarts.init(document.getElementById("ageData"))
      let option = {
        color: [
          "#3BA0FF",
          "#2CD1C0",
          "#4DCB73",
          "#FAD337",
          "#F2637B",
          "#975FE4",
        ],
        title: {
          text: "年龄段占比",
          left: "4%",
          top: "0%",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} :  ({d}%)",
        },
        legend: {
          left: "55%",
          y: "center",
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 16,
          },
        },
        grid: {
          left: "0%",
          top: "18%",
          right: "12%",
          bottom: "18%",
          containLabel: false,
        },
        series: [
          {
            name: "",
            type: "pie",
            center: ["30%", "50%"],
            radius: ["30%", "50%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.oldNumList,
          },
        ],
      }
      option && myAgeEchart.setOption(option)
    },
    // 健康分析
    healthyEcharts() {
      // console.log(this.healthyList)
      let myHealthyEcharts = this.$echarts.init(
        document.getElementById("moneyData")
      )
      let option = {
        color: ["#FA7093", "#2B94F2", "#FBB828", "#2CD1C0", "#E8BDF3"],
        title: {
          text: "健康分析",
          left: "4%",
          top: "0%",
          textStyle: {
            color: "#fff",
            fontSize: 16,
          },
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          show: false,
        },
        grid: {
          left: "15%",
          top: "20%",
          right: "3%",
          bottom: "18%",
          containLabel: false,
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            center: ["50%", "60%"],
            data: this.healthyList,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      }
      option && myHealthyEcharts.setOption(option)
    },
    //请假统计
    getaskLeave() {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findQingJiaCount",
        method: "POST",
        data: {},
      }).then((res) => {
        // console.log(res)
        if (res.code == 200) {
          if (res.content != null) {
            this.qingjia = res.content.qingjia
          } else if (res.content == null) {
            this.qingjia = 0
          }
        }
      })
    },
    //逾期未归
    getOutTime() {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findOutTimeCount",
        method: "POST",
        data: {},
      }).then((res) => {
        // console.log(res)
        if (res.code == 200) {
          if (res.content != null) {
            this.outtime = res.content.yuqiweigui
          }
        }
      })
    },
    //建筑面积 房屋质量
    getHouse() {
      const that = this
      request({
        url: "/jjyl/admin/center/customer/info/findBaseSituationCount",
        method: "POST",
        data: {},
      }).then((res) => {
        // console.log(res)
        if (res.code == 200) {
          if (res.content != null) {
            this.builtArea = res.content.builtArea
            this.houseNum = res.content.houseNum
          }
        }
      })
    },
    // 入院老人柱形图
    echartHosiptial() {
      let hosiptialCharts = this.$echarts.init(
        document.getElementById("hospitalOld")
      )
      let option
      option = {
        color: ["#2B94F2", "#FBB828"],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["男", "女"],
          left: "5%",
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 16,
          },
        },
        grid: {
          left: "9%",
          top: "18%",
          right: "3%",
          bottom: "18%",
          containLabel: false,
        },
        toolbox: {
          show: true,
          feature: {
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ["line", "bar"] },
            restore: { show: false },
            saveAsImage: { show: false },
          },
        },

        xAxis: [
          {
            type: "category",
            data: [
              "60岁以下",
              "60岁-69岁",
              "70岁-79岁",
              "80岁-89岁",
              "90岁以上",
            ],
            axisLine: {
              lineStyle: {
                color: "#fff",
                width: 1, //这里是为了突出显示加上的
              },
            },
            axisLabel: {
              interval: 0,
              rotate: 45,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#fff",
                width: 1, //这里是为了突出显示加上的
              },
            },
          },
        ],
        series: [
          {
            name: "男",
            type: "bar",
            data: this.oldManNumList,
          },
          {
            name: "女",
            type: "bar",
            data: this.oldWomenNumList,
          },
        ],
      }

      option && hosiptialCharts.setOption(option)
    },
    // 查看更多及返回
    serveClick(val) {
      if (this.vodelist.length > 1) {
        if (val == 1) {
          this.serveCad = true
        } else {
          this.serveCad = false
        }
      } else {
        this.$message.error("暂无更多数据")
      }
      // console.log(this.serveCad)
    },
    // 获取菜单
    getMealList() {
      this.$http
        .request({
          url: "/jgyl/admin/instituWeeklyMenu/todayMenu",
          method: "POST",
          data: {},
        })
        .then((res) => {
          // console.log(res)
          if (res.code == 200) {
            if (JSON.stringify(res.content) === "[]" || res.content == null) {
              this.mealList = [
                { foodName: "" },
                { foodName: "" },
                { foodName: "" },
              ]
            } else {
              this.mealList = res.content
            }
          }
        })
    },
    // 获取疾病统计
    getMoneyss() {
      request({
        url: "/jgyl/admin/register/info/findHealthAnalysis",
        method: "POST",
        data: {},
      }).then((res) => {
        // console.log(res)
        if (res.code == 200) {
          if (res.content != null) {
            this.healCondition = res.content
            this.echartMoneyss(this.healCondition)
          }
        }
      })
    },
    //健康分析
    echartMoneyss(Hdata) {
      let mayCharts = this.$echarts.init(document.getElementById("coesada"))
      let colorList = [
        [
          "#ff7f50",
          "#87cefa",
          "#da70d6",
          "#32cd32",
          "#6495ed",
          "#ff69b4",
          "#ba55d3",
          "#cd5c5c",
          "#ffa500",
          "#40e0d0",
          "#1e90ff",
          "#ff6347",
          "#7b68ee",
          "#d0648a",
          "#ffd700",
          "#6b8e23",
          "#4ea397",
          "#3cb371",
          "#b8860b",
          "#7bd9a5",
        ],
        [
          "#ff7f50",
          "#87cefa",
          "#da70d6",
          "#32cd32",
          "#6495ed",
          "#ff69b4",
          "#ba55d3",
          "#cd5c5c",
          "#ffa500",
          "#40e0d0",
          "#1e90ff",
          "#ff6347",
          "#7b68ee",
          "#00fa9a",
          "#ffd700",
          "#6b8e23",
          "#ff00ff",
          "#3cb371",
          "#b8860b",
          "#30e0e0",
        ],
        [
          "#929fff",
          "#9de0ff",
          "#ffa897",
          "#af87fe",
          "#7dc3fe",
          "#bb60b2",
          "#433e7c",
          "#f47a75",
          "#009db2",
          "#024b51",
          "#0780cf",
          "#765005",
          "#e75840",
          "#26ccd8",
          "#3685fe",
          "#9977ef",
          "#f5616f",
          "#f7b13f",
          "#f9e264",
          "#50c48f",
        ],
      ][2]
      let option = {
        title: {
          show: true,
          text: '"',
          x: "center",

          // 'center' ¦ 'left' ¦ 'right'
          // ¦ {number}（x坐标，单位px）
          y: "bottom",

          // 'top' ¦ 'bottom' ¦ 'center'
          // ¦ {number}（y坐标，单位px）
          //textAlign: null          // 水平对齐方式，默认根据x设置自动调整
          backgroundColor: "rgba(0,0,0,0)",
          borderColor: "rgba(0,0,0,0)",
          borderWidth: 0,
          padding: 5,

          // 接受数组分别设定上右下左边距，同css
          itemGap: 10,
          textStyle: {
            fontSize: 18,
            fontWeight: "bolder",
            color: "#fff", // 主标题文字颜色
          },
          subtextStyle: {
            color: "#fff", // 副标题文字颜色
          },
        },
        backgroundColor: "rgba(0, 255, 255, 0)",
        tooltip: {},
        animationDurationUpdate: function (idx) {
          // 越往后的数据延迟越大
          return idx * 100
        },
        animationEasingUpdate: "bounceIn",
        color: ["#fff", "#fff", "#fff"],
        series: [
          {
            type: "graph",
            layout: "force",
            force: {
              repulsion: 500,
              edgeLength: 10,
            },
            roam: true,
            label: {
              normal: {
                show: true,
              },
            },
            data: [
              {
                name: "高血脂",
                value: Hdata.GXZ,
                symbolSize: 48,
                draggable: true,
                itemStyle: {
                  normal: {
                    shadowBlur: 100,
                    shadowColor: colorList[0],
                    color: colorList[0],
                  },
                },
              },
              {
                name: "脑卒中",
                value: Hdata.NCZ,
                symbolSize: 73,
                draggable: true,
                itemStyle: {
                  normal: {
                    shadowBlur: 100,
                    shadowColor: colorList[1],
                    color: colorList[1],
                  },
                },
              },
              {
                name: "重性精神病",
                value: Hdata.ZXJSB,
                symbolSize: 67,
                draggable: true,
                itemStyle: {
                  normal: {
                    shadowBlur: 100,
                    shadowColor: colorList[2],
                    color: colorList[2],
                  },
                },
              },
              {
                name: "高血压",
                value: Hdata.GXY,
                symbolSize: 50,
                draggable: true,
                itemStyle: {
                  normal: {
                    shadowBlur: 100,
                    shadowColor: colorList[3],
                    color: colorList[3],
                  },
                },
              },
              {
                name: "冠心病",
                value: Hdata.GXB,
                symbolSize: 88,
                draggable: true,
                itemStyle: {
                  normal: {
                    shadowBlur: 100,
                    shadowColor: colorList[4],
                    color: colorList[4],
                  },
                },
              },
              {
                name: "身体健康",
                value: Hdata.STJK,
                symbolSize: 134,
                draggable: true,
                itemStyle: {
                  normal: {
                    shadowBlur: 100,
                    shadowColor: colorList[5],
                    color: colorList[5],
                  },
                },
              },
              {
                name: "糖尿病",
                value: Hdata.TNB,
                symbolSize: 45,
                draggable: true,
                itemStyle: {
                  normal: {
                    shadowBlur: 100,
                    shadowColor: colorList[6],
                    color: colorList[6],
                  },
                },
              },
              {
                name: "类风湿",
                value: Hdata.LFS,
                symbolSize: 50,
                draggable: true,
                itemStyle: {
                  normal: {
                    shadowBlur: 100,
                    shadowColor: colorList[7],
                    color: colorList[7],
                  },
                },
              },
              {
                name: "其他",
                value: Hdata.QT,
                symbolSize: 57,
                draggable: true,
                itemStyle: {
                  normal: {
                    shadowBlur: 100,
                    shadowColor: colorList[7],
                    color: colorList[7],
                  },
                },
              },
            ],
          },
        ],
      }
      option && mayCharts.setOption(option)
    },
  },
}
</script>
<style lang="less" scoped>
.homeMain {
  position: relative;
  padding: 0px 12px;
  display: flex;
  max-width: 1920px;
  margin: auto;
  .serveTitle {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    padding-left: 22px;
    padding-top: 20px;
  }
  .companyImg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .homeLeft {
    flex: 1;
    .map-top {
      width: 100%;
      position: relative;
      height: 56vh;
      .trangle {
        width: 34px;
        height: 34px;
        z-index: 1111;
        position: absolute;
        &.trangle1 {
          left: 0px;
          top: 0px;
        }
        &.trangle2 {
          right: -4px;
          bottom: -4px;
          transform: rotate(180deg);
        }
        &.trangle3 {
          left: 0px;
          bottom: -4px;
          transform: rotate(-90deg);
        }
        &.trangle4 {
          right: -4px;
          top: 0px;
          transform: rotate(90deg);
        }
      }
      .selectMap {
        width: 260px;
        height: 45px;
        border-radius: 8px;
        position: absolute;
        left: 30px;
        top: 30px;
        z-index: 3;
        .el-select {
          width: 100%;
          /deep/ .el-input--suffix .el-input__inner {
            background-color: transparent !important;
            border: 1px solid #2e9eff;
            color: #fff;
            border-radius: 8px;
          }
        }
      }
      .trangleRight {
        width: 217px;
        height: 96px;
        position: absolute;
        right: -4px;
        top: 0px;
        z-index: 12;
      }
      .serveMap {
        border: 2px solid #2785dc;
        width: 100%;
        height: 100%;
      }
    }
    .map-bottom {
      width: 100%;
      height: 33vh;
      position: relative;
      margin-top: 12px;
      overflow: hidden;
      .old-left {
        float: left;
        width: 100%;
        p {
          color: #fff;
          text-align: left;
          font-size: 18px;
          margin-top: 12px;
          margin-bottom: 14px;
          margin-left: 12px;
        }
        .analyse {
          display: flex;
          .analyse-left {
            flex: 1;
            #ageData {
              width: 100%;
              margin-top: 10px;
              height: 20vh;
            }
          }
          .analyse-right {
            flex: 1;
            #moneyData {
              width: 100%;
              margin-top: 10px;
              height: 20vh;
            }
          }
        }
      }
      .old-right {
        float: left;
        width: 30%;
        p {
          color: #fff;
          text-align: left;
          font-size: 18px;
          margin-top: 12px;
          margin-bottom: 14px;
          margin-right: 12px;
        }
        ul {
          overflow: hidden;
          li {
            float: left;
            width: 46%;
            margin-right: 4%;
            p {
              color: #fff;
              font-size: 16px;
            }
            div {
              width: 67px;
              height: 77px;
              position: relative;
              line-height: 77px;
              text-align: center;
              span {
                color: #fff;
                font-size: 15px;
                position: absolute;
                left: 0;
                right: 0;
                z-index: 99;
              }
              img {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                right: 0;
                width: 100%;
                height: 100%;
              }
            }
          }
          li:nth-child(2n) {
            margin-right: 0;
          }
        }
      }
    }
  }

  .homeCenter {
    width: 24%;
    margin-left: 12px;
    .serveObj {
      width: 100%;
      height: 54vh;
      position: relative;

      .serveObjTop {
        padding-top: 7%;
        height: 43vh;
        position: relative;
        z-index: 99;
        overflow-y: auto;
        .sertitle {
          color: #fff;
          font-size: 18px;
          margin-left: 20px;
        }
        .today {
          margin-top: 3%;
          margin-bottom: 3%;
        }
        .serveBox {
          padding: 10px 10px;
          display: flex;
          justify-content: space-between;
          height: 67px;
          .serveOther {
            flex: 1;
            text-align: center;
            cursor: pointer;
            .servepo {
              position: relative;
              margin-left: 27%;
              width: 67px;
              height: 77px;
              position: relative;
              line-height: 77px;
              text-align: center;
              margin-bottom: 3px;
              span {
                color: #fff;
                font-size: 15px;
                position: absolute;
                left: 0;
                right: 0;
                z-index: 99;
                margin-left: -18%;
              }
              img {
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                width: 100%;
                height: 100%;
              }
            }
            .write {
              color: #fff;
              font-size: 14px;
            }
            img {
              width: 34px;
              height: 32px;
              margin-left: -12%;
              margin-right: 20px;
            }
            p {
              display: inline-block;
              .name {
                color: #fff;
                font-size: 12px;
                text-align: center;
                display: inline-block;
                margin-bottom: 5px;
              }
              .nums {
                font-size: 20px;
                color: #fa7093;
                font-weight: bold;
                display: inline-block;
                margin-top: 8px;
              }
            }
          }
          .serveItem {
            position: relative;
            width: 151px;
            height: 67px;
            .name {
              width: 80px;
              line-height: 24px;
              color: #fff;
              font-size: 12px;
              text-align: center;
              padding-left: 60px;
            }
            .nums {
              font-size: 20px;
              font-weight: bold;
              width: 80px;
              text-align: center;
              line-height: 38px;
              padding-left: 60px;
              color: #fff;
              padding-top: 4px;
            }
            // background: #01b1ff;
            &.serveItem1 {
              margin: 0px 15px;
            }
          }
        }
      }
    }
    .demographic {
      width: 100%;
      position: relative;
      margin-top: 12px;
      height: 35vh;
      #hospitalOld {
        width: 100%;
        margin-top: 10px;
        height: 32vh;
      }
    }
  }
  .homeRight {
    width: 41%;
    margin-left: 12px;
    .companyServe {
      width: 100%;
      height: 39vh;
      margin-top: 5px;
      position: relative;
      overflow: hidden;
      .compayTop {
        position: relative;
        z-index: 1000;
        display: flex;
        align-items: center;
        .companyName {
          flex: 1;
          color: #fff;
          font-size: 16px;
          font-weight: bold;
          padding-left: 20px;
          margin-top: 5%;
        }
        .companyTab {
          padding: 15px 20px;
          span {
            cursor: pointer;
            display: inline-block;
            text-align: center;
            color: #6ebcff;
            font-size: 14px;
            border: 2px solid rgba(46, 158, 255, 0.8);
            line-height: 28px;
            border-radius: 4px;
            width: 114px;
            &.curIndex {
              background: #2889fe;
              color: #fff;
            }
          }
        }
      }
      .companyHead {
        background: linear-gradient(to right, #01b1ff, #2e9eff);
        margin: 12px 12px 0px;
        display: flex;
        line-height: 40px;
        color: #fff;
        font-size: 15px;
        height: 40px;
        text-align: center;
        .item {
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .item2 {
          flex: 2;
        }
      }
      .nocolorHead {
        background: none;
        margin-top: 0;
      }

      .compayDes {
        height: 14vh;
        overflow: hidden;
        padding: 12px;
        margin-top: 12px;
        .desItem {
          display: flex;
          text-align: center;
          align-items: center;
          font-size: 14px;
          line-height: 24px;
          color: #01b1ff;
          .item {
            flex: 1;
          }
          .item2 {
            flex: 2;
          }
        }
      }
    }
    .serveStation {
      position: relative;
      width: 100%;
      height: 50vh;
      overflow: hidden;
      .over {
        overflow-x: hidden;
        overflow-y: scroll;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .prism-player {
          height: 200px;
        }
      }
      .over::-webkit-scrollbar {
        display: none;
      }
    }
  }
}

/deep/ .el-dialog {
  width: 40%;
  background: #021d36;
}
/deep/ .el-dialog__header {
  padding: 15px 20px;
  position: relative;
  z-index: 2;
}
/deep/ .el-dialog__title {
  color: #fff;
}
/deep/ .el-dialog__body {
  padding: 10px 20px;
  .dialogConent {
    ul {
      li {
        padding: 15px 10px;
        border: 1px solid #333;
        margin-bottom: 15px;
        display: flex;
        position: relative;
        .activeImg {
          position: absolute;
          top: 0;
          right: 0;
          width: 170px;
          background: #021d36;
          z-index: 2;
        }
        p {
          flex: 1;
          span {
            color: #fefefe;
            &:nth-child(1) {
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
}

// 模态框表格
.tableData {
  color: #fff;
  position: relative;
  z-index: 99;
  overflow: hidden;
  width: 100%;
  ul:first-child {
    margin-top: 15px;
  }
  ul:nth-child(2n + 2) li {
    border-top: none;
    border-bottom: none;
  }
  ul {
    // border: 1px solid steelblue;
    margin-bottom: 10px;
    margin: 0 5%;
    margin-top: 10%;
    width: 95%;
    overflow: hidden;
    margin-top: 0;
    li {
      border: 1px solid steelblue;
      float: left;
      text-align: center;

      // line-height:80px;
    }
    li:first-child {
      width: 28%;
      height: 80px;
      line-height: 80px;
      border-right: none;
    }
    li:last-child {
      width: 60%;
      height: 70px;
      padding-top: 10px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
  margin-top: 16px;
}
.overdiv div:hover {
  cursor: pointer;
}
#coesada {
  width: 90%;
  margin: 0 10px;
  margin-top: 10px;
  height: 32vh;
}
</style>
